import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="towns"
export default class extends Controller {
  static targets = ['query', 'suggestions', 'town','istatCode', 'districtCode', 'districtName', 'regionName'];
  static values = {
    url: String,
    sleep: Number,
    min: Number,
    hide: Boolean
  }
  
  connect() {
    console.log('Town autocomplete');
    console.log('urlValue', this.urlValue);
    console.log('sleepValue', this.sleepValue);
    console.log('hideValue', this.hideValue);
    console.log('minValue', this.minValue);
  }

  search() {
    var value = this.townTarget.value;
    var sleep = this.sleepValue;
    var min = 2; 
    if(this.minValue){ min = this.minValue; }

    if(value && value.length >= min){
      var url = this.urlValue + '?query=' + value;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchTown(url);
      }, sleep);
    }
  }

  searchTown(url) {
    console.log('url: ', url);

    this.suggestionsTarget.classList.remove('hidden');

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      response.text().then((html) => {
        // console.log('html:', html);
        this.suggestionsTarget.insertAdjacentHTML('beforeend', html);
      });
    });

  }

  selected(event) {
    console.log("selected:", event.srcElement.dataset);

    var dataset = event.srcElement.dataset;

    if(dataset && dataset.town.length){
      this.istatCodeTarget.value = dataset.code;
      // this.districtCodeTarget.value = dataset.districtCode;
      this.districtNameTarget.value = dataset.district;
      // this.regionNameTarget.value = dataset.region;
      this.townTarget.value = dataset.town;

      this.suggestionsTarget.classList.add('hidden');
    }
  }
}
